var map = {
	"./renders/CopyButton/index.js": 5662,
	"./renders/DefaultAssignmentPlans/index.js": 5898,
	"./renders/InheritableAssignmentPlan/index.js": 5663,
	"./renders/PeerNomLockReset/index.js": 5664,
	"./renders/PercentComplete/index.js": 5665,
	"./renders/Rescore/index.js": 5899,
	"./renders/StudentLauncher/index.js": 5666,
	"./renders/UploadImage/index.js": 1106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2063;